
import { Component, Vue, Watch } from "vue-property-decorator";
import BeneficiarioNoAfiliado from "@/models/BeneficiarioNoAfiliado";
import AfiliadoService from "@/services/AfiliadoService";
import ParametrosCatalogo from "../models/ParametrosCatalogo";
import CatalogoResponse from "../models/CatalogoResponse";
import { AxiosResponse } from "axios";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import Swal from "sweetalert2";
import ConsultaFallecido, { ConsultaValidacionBeneficiarioResp } from '@/models/ConsultaFallecido';
import validateDominicanId from 'validacion-cedula-dominicana';
import { Getter } from 'vuex-class';
import VeeValidateForm from '@/vee-validate/types/VeeValidateForm'; 
import Aterisk from "@/components/sobrevivencia/Aterisk.vue";

@Component({components:{Aterisk}})
export default class RegistroBeneficiario extends Vue {
    public beneficiarioNoAfiliado: BeneficiarioNoAfiliado = new BeneficiarioNoAfiliado();
    public afiliadoService: AfiliadoService = new AfiliadoService();
    public confirmPassword: string = "";
    public loading = false;
    // public Toast = Swal.mixin({
    //     toast: true,
    //     position: "top-end",
    //     showConfirmButton: false,
    //     timer: 3000,
    //     timerProgressBar: true,
    //     onOpen: toast => {
    //         toast.addEventListener("mouseenter", Swal.stopTimer);
    //         toast.addEventListener("mouseleave", Swal.resumeTimer);
    //     }
    // });
    @Getter('cedulaBeneficiarioNoRegistrado') cedulaBeneficiarioNoRegistrado: string;

    //#region Select Ciudades
    public codCiudad: CatalogoResponse = null;
    public ciudades: Array<CatalogoResponse> = [];
    public ciudadesLoading: boolean = false;
    //#endregion

    //#region Select Sectores
    public codSector: CatalogoResponse = null;
    public sectores: Array<CatalogoResponse> = [];
    public sectoresLoading: boolean = false;
    //#endregion

    //#region Select Vias Notificacion
    public viaNotificacion: CatalogoResponse = null;
    public viasNotificacion: Array<CatalogoResponse> = [];
    public viasNotificacionLoading: boolean = false;
    //#endregion

    public async mounted() {
        await this.getCiudades();
        await this.getViasNotificacion();
        if (this.cedulaBeneficiarioNoRegistrado) {
            this.beneficiarioNoAfiliado.cedulaBeneficiario = this.cedulaBeneficiarioNoRegistrado;
            this.consultarBeneficiario();
        }
    }

    @Watch('codCiudad')
    public async onSelectCiudad() {
        //reset sectores
        this.codSector = null;
        await this.getSectores();
    }

    get calleIsRequired() {
        let result = ((this.beneficiarioNoAfiliado.numero && this.beneficiarioNoAfiliado.numero.length > 0)
                || (this.beneficiarioNoAfiliado.apartamento && this.beneficiarioNoAfiliado.apartamento.length > 0)
                || (this.beneficiarioNoAfiliado.edificio && this.beneficiarioNoAfiliado.edificio.length > 0))
        return result;
    }

    public async getCiudades(term: string = null) {
        if (term && term.length <= 3) {
            return;
        }

        this.ciudadesLoading = true;
        const response = await this.afiliadoService.ciudades(term);
        if (response.data.entity) {
            this.ciudades = response.data.entity;
        } else {
            this.ciudades = [];
        }
        this.ciudadesLoading = false;
    }

    public async getSectores(term: string = null) {
        if (!(this.codCiudad && this.codCiudad.value)) {
            return;
        }

        if (term && term.length <= 3) {
            return;
        }

        this.sectoresLoading = true;
        const response = await this.afiliadoService.sectores(term, new ParametrosCatalogo(this.codCiudad.value));
        if (response.data.entity) {
            this.sectores = response.data.entity;
        } else {
            this.sectores = [];
        }
        this.sectoresLoading = false;
    }

    public async getViasNotificacion(term: string = null) {
        if (term && term.length <= 3) {
            return;
        }

        this.viasNotificacionLoading = true;
        const response = await this.afiliadoService.viasNotificacion(term);
        if (response.data.entity) {
            this.viasNotificacion = response.data.entity;
        } else {
            this.viasNotificacion = [];
        }
        this.viasNotificacionLoading = false;
    }

    public checkFormValid(prop: any, index: number) {
        if (index === 0) {
            (this.$refs.generalDataForm as VeeValidateForm)
                .validate()
                .then((isValid: boolean) => {
                    if (isValid) {
                        prop.nextTab();
                    }
                });
        }
        if (index === 1) {
            (this.$refs.locationForm as VeeValidateForm)
                .validate()
                .then((isValid: boolean) => {
                    if (isValid) {
                        prop.nextTab();
                    }
                });
        }
    }

    public async step1IsValid() {
        const isValid = await (this.$refs.generalDataForm as VeeValidateForm).validate();
        return isValid;
    }

    public async step2IsValid() {
        const isValid = await (this.$refs.locationForm as VeeValidateForm).validate();
        return isValid;
    }

    public registrar(): void {
        if (this.codCiudad) {
            if(this.codCiudad.value) {
                this.beneficiarioNoAfiliado.codCiudad = this.codCiudad.value;
            }
        }
        if (this.codSector) {
            if (this.codSector.value){
                this.beneficiarioNoAfiliado.codSector = this.codSector.value;
            }
        }
        if (this.viaNotificacion) {
            if (this.viaNotificacion.value) {
                this.beneficiarioNoAfiliado.viaNotificacion = this.viaNotificacion.value;
            }
        }
        (this.$refs.passwordForm as VeeValidateForm).validate().then((isValid: boolean) => {
            if (isValid) {
                this.loading = true;
                Swal.fire({
                    text: "¿Seguro de que quieres registrar los datos?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancelar",
                    confirmButtonColor: "#0F6CBC",
                    cancelButtonColor: "#ED8B2F",
                    confirmButtonText: "OK",
                    reverseButtons: true
                }).then(result => {
                    if (result.value) {
                        if (
                            (this.confirmPassword === this.beneficiarioNoAfiliado.password) &&
                            !(!this.beneficiarioNoAfiliado.password || this.beneficiarioNoAfiliado.password.length < 10)
                        ) {
                            Swal.fire({
                                text: "Se están registrando tus datos",
                                icon: "info",
                                timerProgressBar: true,
                                onBeforeOpen: () => {
                                    Swal.showLoading();
                                }
                            });
                            this.afiliadoService
                                .registroBeneficiarioNoAfiliado(
                                    this.beneficiarioNoAfiliado
                                )
                                .then(response => {
                                    Swal.close();
                                    if (response.data.respCode === 200) {
                                        Swal.fire({
                                            text: "Se registraron tus datos",
                                            icon: "success",
                                            showConfirmButton: false,
                                            timer: 3000,
                                            onClose: () => {
                                                this.loading = false;
                                                this.$router.push(
                                                    "/registro-sobrevivencia"
                                                );
                                            }
                                        });
                                    } else if (response.data.respCode === 500) {
                                        Swal.fire({
                                            text: "Hubo un error registrando tus datos",
                                            icon: "error",
                                            showConfirmButton: false,
                                            timer: 3000
                                        });
                                    } else {
                                        Swal.fire({
                                            title: 'Cédula registrada anteriormente',
                                            text: "Si no recuerdas tu clave, puedes ir a la recuperación de clave",
                                            icon: "warning",
                                            showConfirmButton: false,
                                            timer: 3000
                                        });
                                    }
                                });
                        }
                    } else {
                        this.loading = false;
                    }
                });
            }
        });
    }

    public consultarBeneficiario(): void {
        const cedula: string = this.beneficiarioNoAfiliado.cedulaBeneficiario;
        if (!validateDominicanId(cedula)) {
            return;
        }
        const consultaFallecido = new ConsultaFallecido();
        consultaFallecido.cedulaBeneficiario = cedula;
        this.afiliadoService.consultarBeneficiario(consultaFallecido).then((response: AxiosResponse<ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>>) => {
            const consultaValidacionBeneficiarioResp = response.data.entity;
            this.beneficiarioNoAfiliado.primerNombre = consultaValidacionBeneficiarioResp.primerNombre || this.beneficiarioNoAfiliado.primerNombre;
            this.beneficiarioNoAfiliado.segundoNombre = consultaValidacionBeneficiarioResp.segundoNombre || this.beneficiarioNoAfiliado.segundoNombre;
            this.beneficiarioNoAfiliado.primerApellido = consultaValidacionBeneficiarioResp.primerApellido || this.beneficiarioNoAfiliado.primerApellido;
            this.beneficiarioNoAfiliado.segundoApellido = consultaValidacionBeneficiarioResp.segundoApellido || this.beneficiarioNoAfiliado.segundoApellido;
            if (consultaValidacionBeneficiarioResp.estaRegistrado) {
                Swal.fire({
                    title: 'Cédula registrada anteriormente',
                    text: "Si no recuerdas tu contraseña puedes ir a la recuperación de contraseña",
                    icon: "warning"
                }).then((result) => {
                    this.$router.push("/cambio-password");
                });
            }
        }).catch((err) => console.log(err));
    }

    public sectorIsRequerido(beneficiario: BeneficiarioNoAfiliado) {
        if (this.sectores && this.sectores.length > 0) {
            return beneficiario.domicilio || beneficiario.numero || beneficiario.edificio;
        } else {
            return false;
        }
    }

    @Watch('beneficiarioNoAfiliado.correoElectronico1')
    public toLowerCorreoElectronico1(): void {
        this.beneficiarioNoAfiliado.correoElectronico1 = this.beneficiarioNoAfiliado.correoElectronico1.toLowerCase();
    }

    @Watch('beneficiarioNoAfiliado.correoElectronico2')
    public toLowerCorreoElectronico2(): void {
        this.beneficiarioNoAfiliado.correoElectronico2 = this.beneficiarioNoAfiliado.correoElectronico2.toLowerCase();
    }

    public focusInputNombre() {
        (this.$refs.inputNombre as any).focus();
    }

    public goBack(){
        this.$router.back()
    }
}
